export enum MessageTemplateType {
  BOOKING_CONFIRMATION = 'BOOKING_CONFIRMATION',
  TOUR_START_REMINDER = 'TOUR_START_REMINDER',
  TOUR_END_REMINDER = 'TOUR_END_REMINDER',
  TOUR_CANCELLATION = 'TOUR_CANCELLATION',
  INVITATION = 'INVITATION',
  BOOKING_CHANGE_PENDING = 'BOOKING_CHANGE_PENDING',
  BOOKING_CHANGE_APPLIED = 'BOOKING_CHANGE_APPLIED',
  BOOKING_WITHDRAWN = 'BOOKING_WITHDRAWN',
  CONSENT_PENDING = 'CONSENT_PENDING',
  CUSTOM = 'CUSTOM',
}

export enum MessageChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export interface MessageTemplateDto {
  id: string | null;
  messageTemplateType: MessageTemplateType;
  channel: MessageChannel;
  subjectTemplate: string | null;
  bodyTemplate: string;
}

export interface SmsTestRequest {
  bodyTemplate: string;
  phoneNumber: string;
}
